import { MOBILE_SCREEN_WIDTH } from './constants';

const init = function () {
  if (document.documentElement.clientWidth <= MOBILE_SCREEN_WIDTH) {
    return;
  }

  $('.KeyFactBox__Link').each((index, element) => {
    const $element = $(element);
    const href = $element.attr('href');

    if (href.indexOf('#') === -1) {
      return;
    }

    const split = href.split('#');

    // something is wrong with the url, ignore
    if (split.length > 2) return;

    const id = '#' + split[1];
    const path = split[0];

    // we're not linking to the current page
    if (path !== window.location.pathname) return;

    $element.on('click', (event) => {
      const $root = jQuery('html, body');

      event.preventDefault();

      $root.animate(
        {
          scrollTop: jQuery(id).offset().top,
        },
        1000,
        function () {
          window.location.hash = path;
        }
      );
    });
  });
};

init();
